var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgTwitterIco = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 27.1 21.56",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "twitter_ico"
  }, /*#__PURE__*/React.createElement("g", {
    id: "twitter_ico-2",
    "data-name": "twitter ico"
  }, /*#__PURE__*/React.createElement("path", {
    id: "twitter-large",
    d: "M23.29,3.62s3,.37,3.81-.19a16.82,16.82,0,0,0-3.9,2.79s1.12,12.34-11.79,15.31c0,0-6.67.56-11.41-3.06,0,0,5.11,1.39,7.89-1.77,0,0-4.73.47-5.94-3.24a13.88,13.88,0,0,0,3.34-.41S.83,12.15.92,7.7a4.54,4.54,0,0,0,2.51.65S-.28,5,2,1.11c0,0,4.92,6,11,5.66a5.25,5.25,0,0,1,8.81-5A8.34,8.34,0,0,0,25.51,0a5.18,5.18,0,0,1-2.22,3.62Z"
  }))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgTwitterIco, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/twitter_ico.ea7f9f37.svg";
export { ForwardRef as ReactComponent };